/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';

import AnalyticsService from 'cio/services/analytics';
import { ComposerEditableEntityAnalyticsData } from 'cio/utils/composer/composer-editable-entity';

export type PreviewPlaintextArgs = {
  plaintext?: string;
  isLoading?: boolean;
  analyticsData?: ComposerEditableEntityAnalyticsData;
};

export default class PreviewPlaintext extends Component<PreviewPlaintextArgs> {
  @service analytics!: AnalyticsService;

  @tracked isShowingPlaintextModal = false;

  @action
  openPreviewModal() {
    this.isShowingPlaintextModal = true;

    if (this.args.analyticsData != null) {
      this.analytics.track('email', 'preview_plaintext', this.args.analyticsData);
    }
  }

  @action
  closePreviewModal() {
    this.isShowingPlaintextModal = false;
  }
}
